import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CreditCardBack.svg",
  "use": "CreditCardBack.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CreditCardBack.svg\"><path d=\"M52.01,49.0209h-40a4,4,0,0,1-4-4v-26a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4v26A4,4,0,0,1,52.01,49.0209Zm0-25a1,1,0,0,0-1-1h-38a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h38a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol